import { defineStore } from 'pinia';

export const useLocalStore = defineStore('local', {
  state: () => ({
    rewardCardError: {
      visible: false,
      closable: false,
      severity: '',
      message: '',
    },
    pageData: {
      rows: [],
      message: '',
    },
  }),
  actions: {
    setPageData(data) {
      this.pageData = data;
    },
  },
});
